// extracted by mini-css-extract-plugin
module.exports = {"button":"RevokeScheduledBreak__button--34h","icon":"RevokeScheduledBreak__icon--3L5","disabled":"RevokeScheduledBreak__disabled--14U"};